//Manages fetching comments, adding a new comment, and displaying the comments.

import React, { useState, useEffect } from "react";
import AddComments from "./AddComments"; // Input component
import ViewComments from "./ViewComments"; // Display component
import "./CommentsSection.css";
// import { fetchComments, addComment } from "../../../api/mock/mockAPI";

const CommentsSection = ({ mediaIndex }) => {
  const [comments, setComments] = useState([]);

  // Fetch comments when component loads
  // useEffect(() => {
  //   fetchComments(mediaIndex).then(setComments);
  // }, [mediaIndex]);
  
  // const handleAddComment = async (mediaid, newComment) => {
  //   console.log("handleAddComment", mediaid, newComment);
  //   const addedComment = await addComment(mediaid, newComment);
  //   if (addedComment) {
  //     setComments((prev) => [...prev, addedComment]);
  //   }
  // };
  

  return (
    <div className="comments-section">
      {/* <ViewComments comments={comments} />
      <AddComments mediaIndex={mediaIndex} onAddComment={handleAddComment} /> */}
    </div>
  );
};

export default CommentsSection;
